import React, { useState, useEffect, useRef } from "react";
import Hammer from "hammerjs";

export default function DecorationSingleItem({
  decoration,
  disableScroll,
  enableScroll,
}) {
  const [width, setWidth] = useState(270);
  const [height, setHeight] = useState(250);
  const elemRef = useRef();

  useEffect(() => {
    const setPinch = (hammer) => {
      hammer.on("pinch", (e) => {
        setHeight(height * e.scale);
        setWidth(width * e.scale);
      });
    };
    const hammertime = new Hammer(elemRef.current);
    hammertime.get("pinch").set({
      enable: true,
      threshold: 0.02,
    });
    setPinch(hammertime);
    return () => {
      hammertime.off("pinch");
    };
  }, []);

  const wheelHandler = (e) => {
    if (e.deltaY < 0) {
      setHeight(height + 1.02);
      setWidth(width + 1.02);
    } else {
      setHeight(height - 1.02);
      setWidth(width - 1.02);
    }
  };

  return (
    <img
      style={{
        width: width + "px",
        height: height + "px",
        maxWidth: "800px",
        minWidth: "50px",
        maxHeight: "800px",
        minHeight: "50px",
      }}
      className="decoration-image decoration-center"
      ref={elemRef}
      onWheel={wheelHandler}
      onMouseEnter={disableScroll}
      onMouseLeave={enableScroll}
      src={decoration.image}
      alt={decoration.name}
      onDragStart={(e) => e.preventDefault()}
    />
  );
}
